import * as React from 'react'
import { currencyString } from '@sales-center/common'
import { useData } from './hooks'
import { Tax, Value } from './styling'
import { ServiceCardProps } from '../typings'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { useLocalizationEnabled } from '@user/store/tenantFeatures/hooks/useLocalizationEnabled'

type Props = Pick<ServiceCardProps, 'frequency' | 'service'>

export function Details(props: Props) {
  const {
    frequency,
    service: {
      chargeTax,
      initialPrice,
      quantity,
      recurringPrice,
      taxRate,
      canadianTaxRate,
      gstHstLabel,
      gstHstRate,
      pstQstLabel,
      pstQstRate,
    },
    service,
  } = props

  const isCanadianTax = useLocalizationEnabled() && canadianTaxRate

  const {
    taxTotal,
    initialDiscount,
    recurringDiscount,
    gstTaxTotal,
    pstTaxTotal,
  } = useData({ service })
  return (
    <Box pb={1}>
      <Grid container flexDirection="column" width={304}>
        <Grid container item flexDirection="row" justifyContent="space-between">
          <Grid item>Quantity</Grid>
          <Value item>{quantity}</Value>
        </Grid>
        <Grid container item flexDirection="row" justifyContent="space-between">
          <Grid item>Frequency</Grid>
          <Value item>{frequency?.description}</Value>
        </Grid>
        <Grid container item flexDirection="row" justifyContent="space-between">
          <Grid item>Initial Price</Grid>
          <Value item>${currencyString(initialPrice)}</Value>
        </Grid>
        <Grid container item flexDirection="row" justifyContent="space-between">
          <Grid item>Initial Discount</Grid>
          <Value item>${currencyString(initialDiscount)}</Value>
        </Grid>
        <Grid container item flexDirection="row" justifyContent="space-between">
          <Grid item>Recurring Price</Grid>
          <Value item>${currencyString(recurringPrice)}</Value>
        </Grid>
        <Grid container item flexDirection="row" justifyContent="space-between">
          <Grid item>Recurring Discount</Grid>
          <Value item>${currencyString(recurringDiscount)}</Value>
        </Grid>

        {isCanadianTax ? (
          <>
            {gstTaxTotal > 0 && (
              <Grid
                container
                item
                flexDirection="row"
                justifyContent="space-between"
              >
                <Grid item>{gstHstLabel}</Grid>
                <Value item>
                  <Tax>{gstHstRate * 100}%</Tax>$
                  {chargeTax ? currencyString(gstTaxTotal) : '0.00'}
                </Value>
              </Grid>
            )}
            {pstTaxTotal > 0 && (
              <Grid
                container
                item
                flexDirection="row"
                justifyContent="space-between"
              >
                <Grid item>{pstQstLabel}</Grid>
                <Value item>
                  <Tax>{pstQstRate * 100}%</Tax>$
                  {chargeTax ? currencyString(pstTaxTotal) : '0.00'}
                </Value>
              </Grid>
            )}
          </>
        ) : (
          <Grid
            container
            item
            flexDirection="row"
            justifyContent="space-between"
          >
            <Grid item>Tax</Grid>
            <Value item>
              <Tax>{taxRate * 100}%</Tax>$
              {chargeTax ? currencyString(taxTotal) : '0.00'}
            </Value>
          </Grid>
        )}
      </Grid>
    </Box>
  )
}
